<script>
import { Line, mixins } from 'vue-chartjs'
const { reactiveProp } = mixins

export default {
  extends: Line,
  mixins: [reactiveProp],
  props: {
    min: {
      type: Number,
      default: 0,
      required: true
    }
  },
  data () {
    return {
      options: {
        responsive: true,
        maintainAspectRatio: false,
        scales: {
          xAxes: [{
            gridLines: {
              display: false
            }
          }],
          yAxes: [{
            ticks: {
              padding: 20,
              suggestedMin: this.min
            },
            gridLines: {
              display: true,
              borderDash: [4, 4],
              drawBorder: false
            }
          }]
        },
        showAllTooltips: true,
        tooltips: {
          callbacks: {
            title: () => ''
          },
          backgroundColor: '#e5f3fe',
          bodyFontColor: '#777777',
          bodyFontStyle: 'bold',
          displayColors: false,
          caretSize: 0,
          mode: 'index',
          position: 'average'
        },
        legend: {
          display: false
        }
      }
    }
  },

  mounted () {
    this.renderChart(this.chartData, this.options)
  }
}
</script>
